import { CommonModule } from "@angular/common";
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    EventEmitter,
    Input,
    OnInit,
    Output,
    signal,
    WritableSignal,
} from "@angular/core";

import {
    IconButtonComponent,
    SECONDARY_EXTRA_LIGHT,
} from "@hermes/aphrodite/icon-button";
import { CurrencyModule } from "@hermes/aphrodite/price";
import { SvgIconComponent } from "@hermes/aphrodite/svg";
import { GridFilterTag } from "@hermes/states/grid-filters-state";

@Component({
    selector: "h-grid-filter-tag",
    standalone: true,
    styleUrls: ["./grid-filter-tag.component.scss"],
    templateUrl: "./grid-filter-tag.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        SvgIconComponent,
        CurrencyModule,
        IconButtonComponent,
    ],
})
export class GridFilterTagComponent implements OnInit {
    @Output()
    public remove = new EventEmitter<GridFilterTag | undefined>();
    @Input() public gridFilterTag!: GridFilterTag;

    public filterTag: WritableSignal<GridFilterTag> = signal({
        id: "",
        filter: {
            name: "",
            selected: false,
            total: 0,
            urlParams: "",
            value: "",
            filterGroupName: "",
            facetIsCrawlable: false,
        },
        gridFilterGroupName: "",
        priceRange: undefined,
    });

    public priceRange = computed(() => this.filterTag().priceRange);
    public valueMinCurrent = computed(
        () => this.filterTag().priceRange?.valueMinCurrent ?? 0,
    );
    public valueMaxCurrent = computed(
        () => this.filterTag().priceRange?.valueMaxCurrent ?? 0,
    );
    protected readonly SECONDARY_EXTRA_LIGHT = SECONDARY_EXTRA_LIGHT;

    public ngOnInit(): void {
        this.filterTag.set(this.gridFilterTag);
    }
}
